<template>
  <div class="kyc-information-manager">
    <b-tabs>
      <b-tab
        title="Director's Information"
        active
      >
        <!-- v-if="isPageShow" -->
        <validation-observer
          ref="kycInformationRules"
        >
          <b-form>
            <div
              class="form-section"
            >
              <h5 class="text-primary mb-2 mt-3">
                Director's Information
              </h5>
              <b-row>
                <b-col md="4">
                  <SelectField
                    id="titles"
                    v-model="localFormData.title"
                    label="Title"
                    :options="titleOptions"
                    :reduce="option => option.value"
                    error-name="Title"
                    rules="required"
                    :readonly="isReadonly"
                    item="label"
                    placeholder="Select"
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="lastname"
                    v-model="localFormData.lastName"
                    label="Last Name"
                    placeholder="Enter last name"
                    type="text"
                    error-name="Last Name"
                    rules="required"
                    :readonly="isKycReadonly || isReadonly"
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="firstname"
                    v-model="localFormData.firstName"
                    label="First Name"
                    placeholder="Enter first name"
                    type="text"
                    error-name="First Name"
                    rules="required"
                    :readonly="isKycReadonly || isReadonly"
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="middlename"
                    v-model="localFormData.middleName"
                    label="Middle Name"
                    placeholder="Enter middle name"
                    type="text"
                    :readonly="isKycReadonly || isReadonly"
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="contact-phone-number"
                    v-model="localFormData.phoneNumber"
                    label="Contact Phone Number"
                    placeholder="Enter contact phone number"
                    type="text"
                    error-name="Contact Phone Number"
                    rules="required|phoneNumber"
                    :readonly="isReadonly"
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="email-address"
                    v-model="localFormData.emailAddress"
                    label="Email Address"
                    placeholder="Enter email address"
                    type="text"
                    error-name="Email Address"
                    rules="required"
                    :readonly="isReadonly"
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="bvn"
                    v-model="localFormData.bvn"
                    label="BVN"
                    placeholder="Enter your bvn"
                    type="number"
                    error-name="BVN"
                    rules="required|max: 11"
                    :readonly="isReadonly"
                  />
                </b-col>
                <b-col md="4">
                  <SelectField
                    id="pep"
                    v-model="localFormData.pep"
                    label="PEP"
                    :options="pepOptions"
                    :reduce="option => option.value"
                    error-name="PEP"
                    rules="required"
                    item="label"
                    placeholder="Select"
                    :readonly="isReadonly"
                  />
                </b-col>
              </b-row>

              <div class="form-section mt-3">
                <h5 class="text-primary mb-2">
                  Valid Identification Details
                </h5>
                <b-row>

                  <b-col md="4">
                    <SelectField
                      id="means-of-id"
                      v-model="localFormData.meansOfIdentification"
                      label="Means of Identification"
                      :options="meansOfIdOptions"
                      :reduce="option => option.value"
                      item="label"
                      error-name="Means of Identification"
                      rules="required"
                      placeholder="Select"
                      :readonly="isReadonly"
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="id-number"
                      v-model="localFormData.idNumber"
                      label="Means of Identification Number"
                      placeholder="Enter identification number on your card"
                      type="text"
                      error-name="Means of Identification Number"
                      rules="required"
                      :readonly="isReadonly"
                    />
                  </b-col>

                  <b-col md="4">
                    <DatePickerField
                      id="issue-date"
                      v-model="localFormData.meansOfIdentificationIssueDate"
                      label="Means of Identification Issue Date"
                      format="Y-m-d"
                      :config="datePickerConfig"
                      :disabled="isReadonly"
                      error-name="Means of Identification Issue Date"
                      rules="required"
                    />
                  </b-col>
                  <b-col md="4">
                    <DatePickerField
                      id="expiry-date"
                      v-model="localFormData.meansOfIdentificationExpiryDate"
                      label="Means of Identification Expiry Date"
                      format="Y-m-d"
                      :min-date="new Date()"
                      :config="meanOfIDdatePickerConfig"
                      :disabled="isReadonly"
                      error-name="Means of Identification Expiry Date"
                      rules="required"
                    />
                  </b-col>

                  <b-col md="4">
                    <InputField
                      id="issuing-authority"
                      v-model="localFormData.meansOfIdentificationPlaceOfIssue"
                      label="Issuing Authority"
                      placeholder="Enter Issuing Authority"
                      type="text"
                      error-name="Issuing Authority"
                      rules="required"
                      :readonly="isReadonly"
                      :is-allow-special-characters="false"
                    />
                  </b-col>
                </b-row>

                <!-- Valid ID -->
                <b-row>
                  <b-col
                    md="12"
                    class="mb-2 mt-3"
                  >
                    <h5 class="text-primary">
                      Upload a Valid ID
                    </h5>
                  </b-col>
                  <b-col
                    sm="12"
                    md="6"
                    lg="4"
                    class="mt-0"
                  >
                    <b-row class="match-height ml-1">
                      <b-col
                        md="8"
                        class="upload-image"
                      >
                        <Spinner :show="!!kycDirectorFile.loading" />

                        <validation-provider
                          v-slot="{ errors }"
                          :name="'Valid ID Document'"
                          :rules="fileRules"
                        >
                          <b-form-group
                            :state="!errors.length"
                            :invalid-feedback="errors[0] || kycDirectorFile.validationError"
                          >
                            <b-form-file
                              v-model="kycDirectorFile.file"
                              :state="!errors.length && !kycDirectorFile.validationError"
                              placeholder="Choose a file or drop it here..."
                              drop-placeholder="Drop file here..."
                              accept=".jpg,.jpeg,.png, .docx,.pdf, application/pdf, .xlsx, .csv"
                              plain
                              :disabled="isReadonly"
                              @change="onKycDocumentFileUpload"
                            />

                            <!-- Instructions -->
                            <div
                              v-if="!kycDirectorFile.url"
                              class="upload-instruction text-center"
                            >
                              <h4>Upload a valid ID</h4>
                              <p>Drag & drop file or choose from your device to upload</p>
                              <p class="format">
                                Format accepted: JPG, PNG, JPEG, DOCX, PDF, XLSX, CSV
                              </p>
                            </div>

                            <!-- Preview -->
                            <div v-else>
                              <b-img
                                v-if="['png','jpeg','jpg','bmp'].includes(kycDirectorFile.fileExtension)"
                                :src="kycDirectorFile.url"
                                block
                                rounded
                                width="250"
                                height="250"
                              />
                              <b-img
                                v-else-if="kycDirectorFile.fileExtension === 'pdf'"
                                :src="pdfIcon"
                                block
                                rounded
                                width="250"
                                height="250"
                              />
                              <b-img
                                v-else-if="kycDirectorFile.fileExtension === 'csv'"
                                :src="csvIcon"
                                block
                                rounded
                                width="250"
                                height="250"
                              />
                              <b-img
                                v-else-if="kycDirectorFile.fileExtension === 'xlsx'"
                                :src="excelIcon"
                                block
                                rounded
                                width="250"
                                height="250"
                              />
                              <b-img
                                v-else-if="kycDirectorFile.fileExtension === 'docx'"
                                :src="wordIcon"
                                block
                                rounded
                                width="250"
                                height="250"
                              />
                              <b-img
                                v-else
                                src=""
                              />

                              <div
                                class="view-details"
                              >
                                <feather-icon
                                  icon="EyeIcon"
                                  size="20"
                                  class="text-primary"
                                  @click="onViewDocumentFile(kycDirectorFile.url, localFormData.meansOfIdentification)"
                                />
                              </div>
                            </div>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col
                        md="4"
                        class="mt-0"
                      >
                        <b-row>
                          <b-col
                            v-if="kycDirectorFile.url"
                            md="12"
                            class="mt-1"
                          >
                            <b-button
                              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                              variant="primary"
                              class="ml-0"
                              @click="handleDownload(kycDirectorFile.url)"
                            >
                              <feather-icon
                                icon="DownloadIcon"
                                class="mr-25"
                              />
                              <span>Download</span>
                            </b-button>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <!-- Valid ID -->
              </div>
              <b-row
                v-if="buttonState"
                class="mt-3"
              >
                <b-col
                  md="12"
                  class="text-center"
                >
                  <Button
                    size="md"
                    :label="directorButtonLabel"
                    @click="addNewKYCDirectors"
                  />
                </b-col>
              </b-row>

            </div>
          </b-form>
        </validation-observer>
        <div>
          <h5 class="text-primary mt-3 mb-1">
            Director's List
          </h5>
          <b-table
            ref="kycInformationListTable"
            select-mode="single"
            :items="tableItems"
            :busy="isKycBusy"
            :per-page="localPerPage"
            :current-page="currentPage"
            responsive
            :fields="tableFields"
            primary-key="id"
            selectable
            show-empty
            empty-text="No data available"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="position-relative mt-3"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner
                  class="align-middle"
                  variant="primary"
                />
              </div>
            </template>
            <template #cell(SN)="data">
              {{ getOverallIndex(data.index) }}
            </template>
            <template #cell(pep)="data">
              <b-badge
                pill
                :variant="getStatusColor(data.value === true ? 'Yes' : 'No')"
              >
                {{ data.value === true ? 'Yes' : 'No' }}
              </b-badge>
            </template>

            <template #cell(status)="data">
              <b-badge
                pill
                :variant="getStatusColor(data.value)"
              >
                {{ data.value }}
              </b-badge>
            </template>

            <template #cell(actions)="data">
              <div class="d-flex align-items-center">
                <div class="text-nowrap mr-2">
                  <Button
                    v-if="getUserPermission('VALIDATE_BVN')"
                    class=""
                    size="sm"
                    label="Validate BVN"
                    @click="bvnValidateAction(data.item)"
                  />
                </div>

                <div class="text-nowrap">
                  <b-dropdown
                    variant="link"
                    toggle-class="p-0"
                    no-caret
                    :right="$store.state.appConfig.isRTL"
                  >
                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </template>
                    <b-dropdown-item
                      v-if="getUserPermission('MODIFY_PFI_ONBOARDING') && !isReadonly"
                      @click="selectKYCInformationItems(data.item, $event.target, data.index, 'edit')"
                    >
                      <feather-icon icon="EditIcon" />
                      <span class="align-middle ml-50">Modify</span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="selectKYCInformationItems(data.item, $event.target, data.index, 'view')"
                    >
                      <feather-icon icon="EyeIcon" />
                      <span class="align-middle ml-50">View</span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="!isReadonly"
                      @click="deleteKYCDirector(data.item)"
                    >
                      <feather-icon icon="TrashIcon" />
                      <span class="align-middle ml-50">Remove Director</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>

            </template>
          </b-table>
        </div>
      </b-tab>
      <b-tab
        title="Bank Information"
      >
        <validation-observer ref="institutionDocumentRules">
          <b-form>
            <div class="form-section">
              <b-row>
                <b-col md="4">
                  <InputField
                    id="bank-name"
                    v-model="kycBankFormData.bankName"
                    label="Institution Name"
                    placeholder="Enter bank name"
                    type="text"
                    error-name="Institution Name"
                    rules="required"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="institution-email-address"
                    v-model="kycBankFormData.institutionEmail"
                    label="Institution Email Address"
                    placeholder="Enter institution email address"
                    type="text"
                    error-name="Institution Email Address"
                    rules="required"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <label
                      for="tin"
                    >TIN</label>
                    <small class="text-muted">Format: 00000000-0000</small>
                  </div>
                  <InputField
                    id="tin"
                    v-model="kycBankFormData.tin"
                    label=""
                    style="margin-top: -35px !important;"
                    placeholder="Enter your TIN"
                    type="text"
                    error-name="TIN"
                    rules="required|validTIN"
                    :readonly="isReadonly"
                  />
                </b-col>
                <b-col md="12">
                  <TextAreaField
                    id="institution-address"
                    v-model="kycBankFormData.institutionAddress"
                    label="Institution Address"
                    placeholder="Enter institution address"
                    type="text"
                    error-name="Institution Address"
                    rules="required"
                    rows="5"
                    readonly
                  />
                </b-col>
              </b-row>
            </div>
            <b-row>
              <!-- Non-Disclosure Agreement -->
              <b-col
                md="6"
                class="mt-2"
              >
                <b-card>
                  <b-row>
                    <b-col
                      md="8"
                      class=" mt-0 ml-5"
                    >
                      <h6 class="section-label mb-2">
                        Non-Disclosure Agreement (NDA)
                      </h6>
                      <Button
                        label="Download Non-Disclosure Agreement"
                        size="md"
                        icon="DownloadIcon"
                        show-icon
                        class="mb-1"
                        disabled
                        @click="downloadKYCDocumentTemplate('GetNDA')"
                      />
                    </b-col>
                  </b-row>
                  <b-col
                    md="9"
                    class="mt-0 ml-3"
                  >
                    <hr class="horizontal-line">
                  </b-col>

                  <b-row class="match-height mb-2 mt-1 ml-5">
                    <b-col
                      md="8"
                      class="upload-image"
                    >
                      <Spinner :show="!!nonDisclosureAgreementFile.loading" />

                      <validation-provider
                        v-slot="{ errors }"
                        :name="'Upload Non-Disclosure Agreement (NDA)'"
                        :rules="fileRules"
                      >
                        <b-form-group
                          :state="!errors.length"
                          :invalid-feedback="errors[0] || nonDisclosureAgreementFile.validationError"
                        >
                          <b-form-file
                            v-model="nonDisclosureAgreementFile.file"
                            :state="!errors.length && !nonDisclosureAgreementFile.validationError"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."
                            accept=".jpg,.jpeg,.png, .docx,.pdf, application/pdf, .xlsx, .csv"
                            plain
                            :disabled="isReadonly"
                            @change="handleKYCFileUpload($event, 'nonDisclosureAgreementFile', 'NonDisclosureAgreement')"
                          />

                          <!-- Instructions -->
                          <div
                            v-if="!nonDisclosureAgreementFile.url"
                            class="upload-instruction text-center"
                          >
                            <h4>Upload Non-Disclosure Agreement (NDA)</h4>
                            <p>Drag & drop file or choose from your device to upload</p>
                            <p class="format">
                              Format accepted: JPG, PNG, JPEG, PDF, DOCX, XLSX, CSV
                            </p>
                          </div>

                          <!-- Preview -->
                          <div v-else>
                            <b-img
                              v-if="['png','jpeg','jpg','bmp'].includes(nonDisclosureAgreementFile.fileExtension)"
                              :src="nonDisclosureAgreementFile.url"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="nonDisclosureAgreementFile.fileExtension === 'pdf'"
                              :src="pdfIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="nonDisclosureAgreementFile.fileExtension === 'docx'"
                              :src="wordIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="nonDisclosureAgreementFile.fileExtension === 'xlsx'"
                              :src="excelIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="nonDisclosureAgreementFile.fileExtension === 'csv'"
                              :src="csvIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else
                              src=""
                            />
                            <div
                              class="view-details"
                            >
                              <feather-icon
                                icon="EyeIcon"
                                size="20"
                                class="text-primary"
                                @click="onViewDocumentFile(nonDisclosureAgreementFile.url, 'Non-Disclosure Agreement')"
                              />
                            </div>
                          </div>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col
                      md="3"
                      class="mt-0"
                    >
                      <b-row>
                        <b-col
                          v-if="nonDisclosureAgreementFile.url"
                          md="12"
                          class="mt-1"
                        >
                          <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            class="ml-0"
                            @click="handleDownload(nonDisclosureAgreementFile.url)"
                          >
                            <feather-icon
                              icon="DownloadIcon"
                              class="mr-25"
                            />
                            <span>Download</span>
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <!-- Non-Disclosure Agreement -->

              <!-- Direct Debit Mandate -->
              <b-col
                md="6"
                class="mt-2"
              >
                <b-card>
                  <b-row>
                    <b-col
                      md="8"
                      class=" mt-0 ml-5"
                    >
                      <h6 class="section-label mb-2">
                        Direct Debit Mandate
                      </h6>
                      <Button
                        label="Download Direct Debit Mandate"
                        size="md"
                        icon="DownloadIcon"
                        show-icon
                        class="mb-1"
                        disabled
                        @click="downloadKYCDocumentTemplate('GetDirectDebitMandate')"
                      />
                    </b-col>
                  </b-row>
                  <b-col
                    md="9"
                    class="mt-0 ml-3"
                  >
                    <hr class="horizontal-line">
                  </b-col>

                  <b-row class="match-height mb-2 mt-1 ml-5">
                    <b-col
                      md="8"
                      class="upload-image"
                    >
                      <Spinner :show="!!directDebitMandateFile.loading" />

                      <validation-provider
                        v-slot="{ errors }"
                        :name="'Upload Direct Debit Mandate'"
                        :rules="fileRules"
                      >
                        <b-form-group
                          :state="!errors.length"
                          :invalid-feedback="errors[0] || directDebitMandateFile.validationError"
                        >
                          <b-form-file
                            v-model="directDebitMandateFile.file"
                            :state="!errors.length && !directDebitMandateFile.validationError"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."
                            accept=".jpg,.jpeg,.png, .docx,.pdf, application/pdf, .xlsx, .csv"
                            plain
                            :disabled="isReadonly"
                            @change="handleKYCFileUpload($event, 'directDebitMandateFile', 'DueDiligenceMandate')"
                          />

                          <!-- Instructions -->
                          <div
                            v-if="!directDebitMandateFile.url"
                            class="upload-instruction text-center"
                          >
                            <h4>Upload Direct Debit Mandate</h4>
                            <p>Drag & drop file or choose from your device to upload</p>
                            <p class="format">
                              Format accepted: JPG, PNG, JPEG, DOCX, PDF, XLSX, CSV
                            </p>
                          </div>

                          <!-- Preview -->
                          <div v-else>
                            <b-img
                              v-if="['png','jpeg','jpg','bmp'].includes(directDebitMandateFile.fileExtension)"
                              :src="directDebitMandateFile.url"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="directDebitMandateFile.fileExtension === 'pdf'"
                              :src="pdfIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="directDebitMandateFile.fileExtension === 'csv'"
                              :src="csvIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="directDebitMandateFile.fileExtension === 'xlsx'"
                              :src="excelIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="directDebitMandateFile.fileExtension === 'docx'"
                              :src="wordIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else
                              src=""
                            />
                            <div
                              class="view-details"
                            >
                              <feather-icon
                                icon="EyeIcon"
                                size="20"
                                class="text-primary"
                                @click="onViewDocumentFile(directDebitMandateFile.url, 'Direct Debit Mandate')"
                              />
                            </div>
                          </div>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col
                      md="3"
                      class="mt-0"
                    >
                      <b-row>
                        <b-col
                          v-if="directDebitMandateFile.url"
                          md="12"
                          class="mt-1"
                        >
                          <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            class="ml-0"
                            @click="handleDownload(directDebitMandateFile.url)"
                          >
                            <feather-icon
                              icon="DownloadIcon"
                              class="mr-25"
                            />
                            <span>Download</span>
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <!-- Direct Debit Mandate -->

              <!-- Anti-Money Laundering Questionnaire -->
              <b-col
                md="6"
                class="mt-2"
              >
                <b-card>
                  <b-row>
                    <b-col
                      md="8"
                      class=" mt-0 ml-5"
                    >
                      <h6 class="section-label mb-2">
                        Anti-Money Laundering Questionnaire
                      </h6>
                      <Button
                        label="Download Anti-Money Laundering Questionnaire"
                        size="md"
                        icon="DownloadIcon"
                        show-icon
                        class="mb-1"
                        disabled
                        @click="downloadKYCDocumentTemplate('GetWolfsbergQuestionnaire')"
                      />
                    </b-col>
                  </b-row>
                  <b-col
                    md="9"
                    class="mt-0 ml-3"
                  >
                    <hr class="horizontal-line">
                  </b-col>

                  <b-row class="match-height mb-2 mt-1 ml-5">
                    <b-col
                      md="8"
                      class="upload-image"
                    >
                      <Spinner :show="!!antiMoneyLaunderingQuestionnaireFile.loading" />

                      <validation-provider
                        v-slot="{ errors }"
                        :name="'Anti-Money Laundering Questionnaire'"
                        :rules="fileRules"
                      >
                        <b-form-group
                          :state="!errors.length"
                          :invalid-feedback="errors[0] || antiMoneyLaunderingQuestionnaireFile.validationError"
                        >
                          <b-form-file
                            v-model="antiMoneyLaunderingQuestionnaireFile.file"
                            :state="!errors.length && !antiMoneyLaunderingQuestionnaireFile.validationError"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."
                            accept=".jpg,.jpeg,.png, .docx,.pdf, application/pdf, .xlsx, .csv"
                            plain
                            :disabled="isReadonly"
                            @change="handleKYCFileUpload($event, 'antiMoneyLaunderingQuestionnaireFile', 'WolfsbergQuestionnaire')"
                          />

                          <!-- Instructions -->
                          <div
                            v-if="!antiMoneyLaunderingQuestionnaireFile.url"
                            class="upload-instruction text-center"
                          >
                            <h4>Upload Anti-Money Laundering Questionnaira</h4>
                            <p>Drag & drop file or choose from your device to upload</p>
                            <p class="format">
                              Format accepted: JPG, PNG, JPEG, DOCX, PDF, XLSX, CSV
                            </p>
                          </div>

                          <!-- Preview -->
                          <div v-else>
                            <b-img
                              v-if="['png','jpeg','jpg','bmp'].includes(antiMoneyLaunderingQuestionnaireFile.fileExtension)"
                              :src="antiMoneyLaunderingQuestionnaireFile.url"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="antiMoneyLaunderingQuestionnaireFile.fileExtension === 'pdf'"
                              :src="pdfIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="antiMoneyLaunderingQuestionnaireFile.fileExtension === 'csv'"
                              :src="csvIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="antiMoneyLaunderingQuestionnaireFile.fileExtension === 'xlsx'"
                              :src="excelIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="antiMoneyLaunderingQuestionnaireFile.fileExtension === 'docx'"
                              :src="wordIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else
                              src=""
                            />
                            <div
                              class="view-details"
                            >
                              <feather-icon
                                icon="EyeIcon"
                                size="20"
                                class="text-primary"
                                @click="onViewDocumentFile(antiMoneyLaunderingQuestionnaireFile.url, 'Anti-Money Laundering Questionnaira')"
                              />
                            </div>
                          </div>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col
                      md="3"
                      class="mt-0"
                    >
                      <b-row>
                        <b-col
                          v-if="antiMoneyLaunderingQuestionnaireFile.url"
                          md="12"
                          class="mt-1"
                        >
                          <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            class="ml-0"
                            @click="handleDownload(antiMoneyLaunderingQuestionnaireFile.url)"
                          >
                            <feather-icon
                              icon="DownloadIcon"
                              class="mr-25"
                            />
                            <span>Download</span>
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <!-- Anti-Money Laundering Questionnaire -->

              <!--  Declaration of Ultimate Beneficial Ownership (UBO) -->
              <b-col
                md="6"
                class="mt-2"
              >
                <b-card>
                  <b-row>
                    <b-col
                      md="8"
                      class=" mt-0 ml-5"
                    >
                      <h6 class="section-label mb-2">
                        Declaration of Ultimate Beneficial Ownership (UBO)
                      </h6>
                      <Button
                        label="Download Declaration of Ultimate Beneficial Ownership (UBO)"
                        size="md"
                        icon="DownloadIcon"
                        show-icon
                        class="mb-1"
                        disabled
                        @click="downloadKYCDocumentTemplate('GetDeclarationOfUBO')"
                      />
                    </b-col>
                  </b-row>
                  <b-col
                    md="9"
                    class="mt-0 ml-3"
                  >
                    <hr class="horizontal-line">
                  </b-col>

                  <b-row class="match-height mb-2 mt-1 ml-5">
                    <b-col
                      md="8"
                      class="upload-image"
                    >
                      <Spinner :show="!!declarationOfUltimateBeneficialOwnershipFile.loading" />

                      <validation-provider
                        v-slot="{ errors }"
                        :name="'Declaration of Ultimate Beneficial Ownership'"
                        :rules="fileRules"
                      >
                        <b-form-group
                          :state="!errors.length"
                          :invalid-feedback="errors[0] || declarationOfUltimateBeneficialOwnershipFile.validationError"
                        >
                          <b-form-file
                            v-model="declarationOfUltimateBeneficialOwnershipFile.file"
                            :state="!errors.length && !declarationOfUltimateBeneficialOwnershipFile.validationError"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."
                            accept=".jpg,.jpeg,.png, .docx,.pdf, application/pdf, .xlsx, .csv"
                            plain
                            :disabled="isReadonly"
                            @change="handleKYCFileUpload($event, 'declarationOfUltimateBeneficialOwnershipFile', 'DeclarationOfUBO')"
                          />

                          <!-- Instructions -->
                          <div
                            v-if="!declarationOfUltimateBeneficialOwnershipFile.url"
                            class="upload-instruction text-center"
                          >
                            <h4>Upload  Declaration of Ultimate Beneficial Ownership</h4>
                            <p>Drag & drop file or choose from your device to upload</p>
                            <p class="format">
                              Format accepted: JPG, PNG, JPEG, DOCX, PDF, XLSX, CSV
                            </p>
                          </div>

                          <!-- Preview -->
                          <div v-else>
                            <b-img
                              v-if="['png','jpeg','jpg','bmp'].includes(declarationOfUltimateBeneficialOwnershipFile.fileExtension)"
                              :src="declarationOfUltimateBeneficialOwnershipFile.url"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="declarationOfUltimateBeneficialOwnershipFile.fileExtension === 'pdf'"
                              :src="pdfIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="declarationOfUltimateBeneficialOwnershipFile.fileExtension === 'csv'"
                              :src="csvIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="declarationOfUltimateBeneficialOwnershipFile.fileExtension === 'xlsx'"
                              :src="excelIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="declarationOfUltimateBeneficialOwnershipFile.fileExtension === 'docx'"
                              :src="wordIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else
                              src=""
                            />
                            <div
                              class="view-details"
                            >
                              <feather-icon
                                icon="EyeIcon"
                                size="20"
                                class="text-primary"
                                @click="onViewDocumentFile(declarationOfUltimateBeneficialOwnershipFile.url, 'Declaration of Ultimate Beneficial Ownership')"
                              />
                            </div>
                          </div>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col
                      md="3"
                      class="mt-0"
                    >
                      <b-row>
                        <b-col
                          v-if="declarationOfUltimateBeneficialOwnershipFile.url"
                          md="12"
                          class="mt-1"
                        >
                          <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            class="ml-0"
                            @click="handleDownload(declarationOfUltimateBeneficialOwnershipFile.url)"
                          >
                            <feather-icon
                              icon="DownloadIcon"
                              class="mr-25"
                            />
                            <span>Download</span>
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <!--  Declaration of Ultimate Beneficial Ownership (UBO) -->

              <!--   Signature Mandate-->
              <b-col
                md="6"
                class="mt-2"
              >
                <b-card>
                  <b-row>
                    <b-col
                      md="8"
                      class=" mt-0 ml-5"
                    >
                      <h6 class="section-label mb-2">
                        Signature Mandate
                      </h6>
                      <Button
                        label="Download Signature Mandate"
                        size="md"
                        icon="DownloadIcon"
                        show-icon
                        class="mb-1"
                        disabled
                        @click="downloadKYCDocumentTemplate('GetSignatureMandate')"
                      />
                    </b-col>
                  </b-row>
                  <b-col
                    md="9"
                    class="mt-0 ml-3"
                  >
                    <hr class="horizontal-line">
                  </b-col>

                  <b-row class="match-height mb-2 mt-1 ml-5">
                    <b-col
                      md="8"
                      class="upload-image"
                    >
                      <Spinner :show="!! signatureMandateFile.loading" />

                      <validation-provider
                        v-slot="{ errors }"
                        :name="'Upload Signature Mandate'"
                        :rules="fileRules"
                      >
                        <b-form-group
                          :state="!errors.length"
                          :invalid-feedback="errors[0] || signatureMandateFile.validationError"
                        >
                          <b-form-file
                            v-model="signatureMandateFile.file"
                            :state="!errors.length && !signatureMandateFile.validationError"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."
                            accept=".jpg,.jpeg,.png, .docx,.pdf, application/pdf, .xlsx, .csv"
                            plain
                            :disabled="isReadonly"
                            @change="handleKYCFileUpload($event, 'signatureMandateFile', 'SignatureMandate')"
                          />

                          <!-- Instructions -->
                          <div
                            v-if="!signatureMandateFile.url"
                            class="upload-instruction text-center"
                          >
                            <h4>Upload Signature Mandate</h4>
                            <p>Drag & drop file or choose from your device to upload</p>
                            <p class="format">
                              Format accepted: JPG, PNG, JPEG, DOCX, PDF, XLSX, CSV
                            </p>
                          </div>

                          <!-- Preview -->
                          <div v-else>
                            <b-img
                              v-if="['png','jpeg','jpg','bmp'].includes(signatureMandateFile.fileExtension)"
                              :src="signatureMandateFile.url"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="signatureMandateFile.fileExtension === 'pdf'"
                              :src="pdfIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="signatureMandateFile.fileExtension === 'csv'"
                              :src="csvIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="signatureMandateFile.fileExtension === 'xlsx'"
                              :src="excelIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="signatureMandateFile.fileExtension === 'docx'"
                              :src="wordIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else
                              src=""
                            />
                            <div
                              class="view-details"
                            >
                              <feather-icon
                                icon="EyeIcon"
                                size="20"
                                class="text-primary"
                                @click="onViewDocumentFile(signatureMandateFile.url, 'Signature Mandate')"
                              />
                            </div>
                          </div>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col
                      md="3"
                      class="mt-0"
                    >
                      <b-row>
                        <b-col
                          v-if="signatureMandateFile.url"
                          md="12"
                          class="mt-1"
                        >
                          <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            class="ml-0"
                            @click="handleDownload(signatureMandateFile.url)"
                          >
                            <feather-icon
                              icon="DownloadIcon"
                              class="mr-25"
                            />
                            <span>Download</span>
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <!--   Signature Mandate-->

              <!--   Board Resolution-->
              <b-col
                md="6"
                class="mt-2"
              >
                <b-card>
                  <b-row>
                    <b-col
                      md="8"
                      class=" mt-0 ml-5"
                    >
                      <h6 class="section-label mb-2">
                        Board Resolution
                      </h6>
                      <Button
                        label="Download Board Resolution"
                        size="md"
                        icon="DownloadIcon"
                        show-icon
                        class="mb-1"
                        disabled
                        @click="downloadKYCDocumentTemplate('GetBoardResolutionTemplate')"
                      />
                    </b-col>
                  </b-row>
                  <b-col
                    md="9"
                    class="mt-0 ml-3"
                  >
                    <hr class="horizontal-line">
                  </b-col>

                  <b-row class="match-height mb-2 mt-1 ml-5">
                    <b-col
                      md="8"
                      class="upload-image"
                    >
                      <Spinner :show="!! boardResolutionFile.loading" />

                      <validation-provider
                        v-slot="{ errors }"
                        :name="'Upload Board Resolution'"
                        :rules="fileRules"
                      >
                        <b-form-group
                          :state="!errors.length"
                          :invalid-feedback="errors[0] || boardResolutionFile.validationError"
                        >
                          <b-form-file
                            v-model="boardResolutionFile.file"
                            :state="!errors.length && !boardResolutionFile.validationError"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."
                            accept=".jpg,.jpeg,.png, .docx,.pdf, application/pdf, .xlsx, .csv"
                            plain
                            :disabled="isReadonly"
                            @change="handleKYCFileUpload($event, 'boardResolutionFile', 'BoardResolutionTemplate')"
                          />

                          <!-- Instructions -->
                          <div
                            v-if="!boardResolutionFile.url"
                            class="upload-instruction text-center"
                          >
                            <h4>Upload Board Resolution</h4>
                            <p>Drag & drop file or choose from your device to upload</p>
                            <p class="format">
                              Format accepted: JPG, PNG, JPEG, DOCX, PDF, XLSX, CSV
                            </p>
                          </div>

                          <!-- Preview -->
                          <div v-else>
                            <b-img
                              v-if="['png','jpeg','jpg','bmp'].includes(boardResolutionFile.fileExtension)"
                              :src="boardResolutionFile.url"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="boardResolutionFile.fileExtension === 'pdf'"
                              :src="pdfIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="boardResolutionFile.fileExtension === 'csv'"
                              :src="csvIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="boardResolutionFile.fileExtension === 'xlsx'"
                              :src="excelIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else-if="boardResolutionFile.fileExtension === 'docx'"
                              :src="wordIcon"
                              block
                              rounded
                              width="250"
                              height="250"
                            />
                            <b-img
                              v-else
                              src=""
                            />
                            <div
                              class="view-details"
                            >
                              <feather-icon
                                icon="EyeIcon"
                                size="20"
                                class="text-primary"
                                @click="onViewDocumentFile(boardResolutionFile.url, 'Board Resolution')"
                              />
                            </div>
                          </div>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col
                      md="3"
                      class="mt-0"
                    >
                      <b-row>
                        <b-col
                          v-if="boardResolutionFile.url"
                          md="12"
                          class="mt-1"
                        >
                          <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            class="ml-0"
                            @click="handleDownload(boardResolutionFile.url)"
                          >
                            <feather-icon
                              icon="DownloadIcon"
                              class="mr-25"
                            />
                            <span>Download</span>
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <!--   Board Resolution-->
            </b-row>
            <!-- <b-row
              v-if="!isReadonly"
              class="mt-3"
            >
              <b-col
                md="12"
                class="text-center"
              >
                <Button
                  size="md"
                  :label="bankButtonLabel"
                  @click="saveKYCInstitutionDocument"
                />
              </b-col>
            </b-row> -->
          </b-form>
        </validation-observer>
      </b-tab>
    </b-tabs>
    <b-modal
      id="view-document-modal"
      ref="avatarModal"
      no-close-on-backdrop
      :ok-title="$t('Download File')"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="viewDocumentModalTitle"
      @hidden="resetDocumentModal"
      @ok="handleDownload(viewDocumentData)"
    >
      <DocumentViewer
        :document-url="viewDocumentData"
        :loading="showSpinnerDoc"
        @loaded="onDocumentLoaded"
        @error="onDocumentError"
      />
    </b-modal>
    <!-- Display Validation Errors -->
    <b-modal
      id="all-validated-modal"
      ref="allValidatedModal"
      ok-title="Cancel"
      ok-only
      no-close-on-backdrop
      ok-variant="outline-secondary"
      centered
      size="md"
      title="Kindly attend to the field(s) below"
      @hidden="resetValidationModal"
    >
      <div
        v-for="(errorItem, index) in allValidationErrors"
        :key="index"
      >
        <p>{{ `${index + 1}.` }} <span style="color: red;"> {{ errorItem }}</span></p>
      </div>
    </b-modal>
    <!-- Display Validation Errors -->
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  BCard, BTabs, BTab, BRow, BCol, BTable, BSpinner, BFormGroup, BFormFile, BImg, BDropdown, BDropdownItem, BForm,
  BBadge, BButton,
} from 'bootstrap-vue'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { toastAlert } from '@core/mixins/toast'
import { v4 as uuidv4 } from 'uuid'
import { permissionMixin } from '@core/mixins/permission'
import Ripple from 'vue-ripple-directive'
import * as FileSaver from 'file-saver'
import { mapActions } from 'vuex'
import getStatusColor from '@/helpers/getStatusColor'
import InputField from '../InputField.vue'
import SelectField from '../SelectField.vue'
import DatePickerField from '../DatePickerField.vue'
import TextAreaField from '../TextAreaField.vue'
import Button from '../../components/button/Button.vue'
import Spinner from '../../components/spinner/Spinner.vue'
import DocumentViewer from '@/views/components/DocumentViewer.vue'
import {
  titleOptions, maritalStatusOptions, meansOfIdOptions,
  pdfIcon, wordIcon,
} from '@/helpers/data'
import { lmsPermissions, accountPermissions } from '@/helpers/permissions'

export default {
  name: 'KycInformation',
  components: {
    ValidationObserver,
    ValidationProvider,
    BCard,
    BTabs,
    BTab,
    BRow,
    BCol,
    BTable,
    BSpinner,
    BFormGroup,
    BFormFile,
    BImg,
    BBadge,
    BButton,
    BDropdown,
    BDropdownItem,
    BForm,
    InputField,
    SelectField,
    DatePickerField,
    TextAreaField,
    Button,
    Spinner,
    DocumentViewer,
  },
  directives: {
    Ripple,
  },
  mixins: [tableMixins, permissionMixin, sweetAlert, toastAlert],
  props: {
    // Form props
    isReadonly: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => ({}),
    },
    initialFormData: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },

    // Options for form selects
    // titleOptions: {
    //   type: Array,
    //   default: () => [],
    // },
    // pepOptions: {
    //   type: Array,
    //   default: () => [],
    // },
    // genderOptions: {
    //   type: Array,
    //   default: () => [],
    // },
    // maritalStatusOptions: {
    //   type: Array,
    //   default: () => [],
    // },
    // employStatusOptions: {
    //   type: Array,
    //   default: () => [],
    // },
    // countryOptions: {
    //   type: Array,
    //   default: () => [],
    // },
    // stateOptions: {
    //   type: Array,
    //   default: () => [],
    // },
    // lgaOptions: {
    //   type: Array,
    //   default: () => [],
    // },
    // meansOfIdOptions: {
    //   type: Array,
    //   default: () => [],
    // },

    // Button configuration
    showAddButton: {
      type: Boolean,
      default: true,
    },
    addButtonLabel: {
      type: String,
      default: 'Add Director',
    },

    // Table props
    showTable: {
      type: Boolean,
      default: true,
    },
    tableTitle: {
      type: String,
      default: 'Directors List',
    },
    tableItems: {
      type: Array,
      default: () => [],
    },
    customFields: {
      type: Array,
      default: () => [],
    },
    // isBusy: {
    //   type: Boolean,
    //   default: false,
    // },
    // perPage: {
    //   type: Number,
    //   default: 10,
    // },
    currentPageProp: {
      type: Number,
      default: 1,
    },
    sortByProp: {
      type: String,
      default: null,
    },
    sortDescProp: {
      type: Boolean,
      default: false,
    },

    // Table action options
    showActions: {
      type: Boolean,
      default: true,
    },
    showBvnValidation: {
      type: Boolean,
      default: false,
    },
    showEditOption: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      getStatusColor,
      pdfIcon,
      wordIcon,
      titleOptions,
      meansOfIdOptions,
      maritalStatusOptions,
      // Form data
      localFormData: { ...this.formData },
      allFetchedData: {},
      localIsReadonly: false,
      isKycReadonly: false,

      // Document upload
      kycDocumentImage: null,
      kycDocumentImageSrc: null,
      hasKycDocumentImage: false,
      uploadKycLoadSpinner: false,
      isKycBusy: false,
      buttonState: false,
      // Date picker configs
      datePickerConfig: {
        dateFormat: 'Y-m-d',
        ariaDateFormat: 'Y-m-d',
      },
      meanOfIDdatePickerConfig: {
        dateFormat: 'Y-m-d',
        minDate: '',
        ariaDateFormat: 'Y-m-d',
      },
      dateOfBirthDatePickerConfig: {
        altInput: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d',
        maxDate: new Date(),
      },

      viewDocumentData: '',
      viewDocumentModalTitle: '',
      showSpinnerDoc: false,
      fileExtension: '',

      // Table data
      localItems: [],
      localPerPage: this.perPage,
      currentPage: this.currentPageProp,
      sortBy: this.sortByProp,
      sortDesc: this.sortDescProp,
      defaultFields: [
        { key: 'SN', label: 'S/N' },
        { key: 'title', sortable: true, label: 'Title' },
        { key: 'lastName', sortable: true, label: 'Last Name' },
        { key: 'firstName', sortable: true, label: 'First Name' },
        { key: 'middleName', sortable: true, label: 'Middle Name' },
        { key: 'phoneNumber', sortable: true, label: 'Phone Number' },
        { key: 'pep', sortable: true, label: 'PEP' },
        { key: 'status', label: 'Status' },
        { key: 'bvn', sortable: true, label: 'BVN' },
        { key: 'actions', label: 'Actions' },
      ],
      directorButtonLabel: '',
      bankButtonLabel: 'Save Bank Information',
      kycDirectorFile: {
        type: '',
        file: null,
        url: '',
        fileExtension: '',
        loading: false,
        validationError: '',
        documentId: '',
      },
      kycBankFormData: {
        tin: '',
        bankName: '',
        institutionEmail: '',
        institutionAddress: '',
      },
      kycInformationList: [],
      partnerCode: '',
      nonDisclosureAgreementFile: {
        type: '',
        file: null,
        url: '',
        fileExtension: '',
        loading: false,
        validationError: '',
        documentId: '',
      },
      directDebitMandateFile: {
        type: '',
        file: null,
        url: '',
        fileExtension: '',
        loading: false,
        validationError: '',
        documentId: '',
      },
      antiMoneyLaunderingQuestionnaireFile: {
        type: '',
        file: null,
        url: '',
        fileExtension: '',
        loading: false,
        validationError: '',
        documentId: '',
      },
      declarationOfUltimateBeneficialOwnershipFile: {
        type: '',
        file: null,
        url: '',
        fileExtension: '',
        loading: false,
        validationError: '',
        documentId: '',
      },
      signatureMandateFile: {
        type: '',
        file: null,
        url: '',
        fileExtension: '',
        loading: false,
        validationError: '',
        documentId: '',
      },
      boardResolutionFile: {
        type: '',
        file: null,
        url: '',
        fileExtension: '',
        loading: false,
        validationError: '',
        documentId: '',
      },
      actionType: 'add',
      fileRules: 'required',
      pepOptions: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
      selectedDirectorIndex: null,
      allValidationErrors: [],
    }
  },
  computed: {
    // Combine default fields with any custom fields passed as props
    tableFields() {
      return [...this.defaultFields, ...this.customFields]
    },
    isImageFile() {
      const imageExtensions = ['png', 'jpeg', 'jpg', 'bmp', 'gif', 'svg', 'webp']
      return imageExtensions.includes(this.fileExtension)
    },
    isWordFile() {
      const wordExtensions = ['doc', 'docx', 'rtf']
      return wordExtensions.includes(this.fileExtension)
    },
    pdfViewerUrl() {
      return this.viewDocumentData
        ? `https://docs.google.com/viewer?url=${encodeURIComponent(this.viewDocumentData)}&embedded=true`
        : null
    },
    wordViewerUrl() {
      return this.viewDocumentData && this.isWordFile
        ? `https://docs.google.com/viewer?url=${encodeURIComponent(this.viewDocumentData)}&embedded=true`
        : null
    },
  },
  watch: {
    // Keep local data in sync with props
    formData: {
      handler(newVal) {
        if (newVal) {
          this.localFormData = { ...newVal }
        }
      },
      deep: true,
      immediate: true,
    },
    tableItems: {
      handler(newVal) {
        if (Array.isArray(newVal)) {
          this.localItems = [...newVal]
        }
      },
      deep: true,
      immediate: true,
    },
    initialFormData: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length) {
          this.localFormData = { ...newVal }
          this.allFetchedData = { ...newVal }
          this.tableItems = newVal.directorsRequest.directors.map(val => ({
            ...val,
            title: val.title,
            lastName: val.lastName,
            firstName: val.firstName,
            middleName: val.middleName,
            phoneNumber: val.phoneNumber,
            pep: val.pep,
            bvn: val.bvn,
          }))

          this.kycBankFormData = {
            tin: newVal.directorsRequest.tin,
            bankName: newVal.directorsRequest.directors[0].bankName,
            institutionEmail: newVal.directorsRequest.directors[0].institutionEmail,
            institutionAddress: newVal.directorsRequest.directors[0].institutionAddress,
          }
          this.partnerCode = newVal.directorsRequest.partnerCode

          const documentMapping = {
            NonDisclosureAgreement: 'nonDisclosureAgreementFile',
            DueDiligenceMandate: 'directDebitMandateFile',
            WolfsbergQuestionnaire: 'antiMoneyLaunderingQuestionnaireFile',
            DeclarationOfUBO: 'declarationOfUltimateBeneficialOwnershipFile',
            SignatureMandate: 'signatureMandateFile',
            BoardResolutionTemplate: 'boardResolutionFile',
          }

          const createEmptyDocument = () => ({
            type: '',
            file: null,
            url: '',
            fileExtension: '',
            loading: false,
            validationError: '',
            documentId: '',
          })

          const resetAllDocuments = () => {
            Object.values(documentMapping).forEach(propName => {
              this[propName] = createEmptyDocument()
            })
          }

          const binaryContent = new Uint8Array([0x25, 0x50, 0x44, 0x46, 0x2D])
          const fakeFile = new File(
            [binaryContent], 'Document.pdf',
            {
              type: 'application/pdf',
              lastModified: new Date().getTime(),
            },
          )
          newVal.documents.forEach(doc => {
            const propertyName = documentMapping[doc.type]

            if (propertyName) {
              this[propertyName] = { ...doc, type: doc.type, file: doc.url ? fakeFile : null }
            } else {
              resetAllDocuments()
            }
          })
        }
        this.emitFormUpdate()
      },
      deep: true,
      immediate: true,
    },
    isEdit: {
      handler(newVal) {
        this.localIsReadonly = newVal
        this.isReadonly = newVal
        this.isDisabled = newVal
      },
      immediate: true,
    },
    currentPageProp(newVal) {
      this.currentPage = newVal
    },
    sortByProp(newVal) {
      this.sortBy = newVal
    },
    sortDescProp(newVal) {
      this.sortDesc = newVal
    },
    perPage(newVal) {
      this.localPerPage = newVal
    },

    nonDisclosureAgreementFile: {
      handler() {
        this.emitFormUpdate()
      },
      deep: true,
    },
    directDebitMandateFile: {
      handler() {
        this.emitFormUpdate()
      },
      deep: true,
    },
    antiMoneyLaunderingQuestionnaireFile: {
      handler() {
        this.emitFormUpdate()
      },
      deep: true,
    },
    declarationOfUltimateBeneficialOwnershipFile: {
      handler() {
        this.emitFormUpdate()
      },
      deep: true,
    },
    signatureMandateFile: {
      handler() {
        this.emitFormUpdate()
      },
      deep: true,
    },
    boardResolutionFile: {
      handler() {
        this.emitFormUpdate()
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      validateBVN: 'eChannels/validateBVNAction',
      uploadDocumentImages: 'account/uploadDocumentImagesAction',
      createKYCDirector: 'account/createKYCDirectorAction',
      updateKYCDirector: 'account/updateKYCDirectorAction',
    }),
    emitFormUpdate() {
      const formData = this.getFormData()
      this.$emit('update', {
        formData: { ...formData },
      })
    },

    getFormData() {
      const directors = this.tableItems.map(item => ({
        ...item,
      }))

      const documents = [
        {
          type: this.nonDisclosureAgreementFile.type,
          url: this.nonDisclosureAgreementFile.url,
          documentId: this.nonDisclosureAgreementFile.documentId,
          fileExtension: this.nonDisclosureAgreementFile.fileExtension,
          tin: this.kycBankFormData.tin,
          partnerCode: this.partnerCode,
        },
        {
          url: this.directDebitMandateFile.url,
          type: this.directDebitMandateFile.type,
          fileExtension: this.directDebitMandateFile.fileExtension,
          documentId: this.directDebitMandateFile.documentId,
          tin: this.kycBankFormData.tin,
          partnerCode: this.partnerCode,
        },
        {
          url: this.antiMoneyLaunderingQuestionnaireFile.url,
          type: this.antiMoneyLaunderingQuestionnaireFile.type,
          fileExtension: this.antiMoneyLaunderingQuestionnaireFile.fileExtension,
          documentId: this.antiMoneyLaunderingQuestionnaireFile.documentId,
          tin: this.kycBankFormData.tin,
          partnerCode: this.partnerCode,
        },
        {
          url: this.declarationOfUltimateBeneficialOwnershipFile.url,
          type: this.declarationOfUltimateBeneficialOwnershipFile.type,
          fileExtension: this.declarationOfUltimateBeneficialOwnershipFile.fileExtension,
          documentId: this.declarationOfUltimateBeneficialOwnershipFile.documentId,
          tin: this.kycBankFormData.tin,
          partnerCode: this.partnerCode,
        },
        {
          url: this.signatureMandateFile.url,
          type: this.signatureMandateFile.type,
          fileExtension: this.signatureMandateFile.fileExtension,
          documentId: this.signatureMandateFile.documentId,
          tin: this.kycBankFormData.tin,
          partnerCode: this.partnerCode,
        },
        {
          url: this.boardResolutionFile.url,
          type: this.boardResolutionFile.type,
          fileExtension: this.boardResolutionFile.fileExtension,
          documentId: this.boardResolutionFile.documentId,
          tin: this.kycBankFormData.tin,
          partnerCode: this.partnerCode,
        },
      ]
      const formData = {
        directorsRequest: {
          directors,
          partnerCode: this.partnerCode,
          tin: this.kycBankFormData.tin,
        },
        documents,
      }
      return formData
    },
    selectKYCInformationItems(item, _, index, val) {
      this.isReadonly = val !== 'edit'
      this.actionType = val
      this.selectedDirectorIndex = index
      this.directorButtonLabel = val === 'edit' ? 'Update Director' : ''
      this.isKycReadonly = val === 'edit' || val === 'view'
      this.buttonState = val === 'edit'

      this.localFormData = {
        lastName: item.lastName,
        firstName: item.firstName,
        middleName: item.middleName,
        title: item.title,
        phoneNumber: item.phoneNumber,
        emailAddress: item.emailAddress,
        bvn: item.bvn,
        pep: item.pep,
        meansOfIdentification: item.meansOfIdentification,
        idNumber: item.idNumber,
        meansOfIdentificationIssueDate: item.meansOfIdentificationIssueDate,
        meansOfIdentificationExpiryDate: item.meansOfIdentificationExpiryDate,
        meansOfIdentificationPlaceOfIssue: item.meansOfIdentificationPlaceOfIssue,
        id: item.id,
      }
      const binaryContent = new Uint8Array([0x25, 0x50, 0x44, 0x46, 0x2D])
      const fakeFile = new File(
        [binaryContent], 'Document.pdf',
        {
          type: 'application/pdf',
          lastModified: new Date().getTime(),
        },
      )
      this.kycDirectorFile = {
        ...item.directorID,
        url: item.directorID.url,
        fileExtension: item.directorID.fileExtension,
        documentId: item.directorID.documentId,
        type: item.directorID.type,
        file: fakeFile,
      }
    },

    async addNewKYCDirectors() {
      this.$refs.kycInformationRules.validate().then(async success => {
        if (success) {
          this.showSpinner = true

          // Extract the common director data object creation
          const createDirectorData = () => ({
            // Bank information
            bankName: this.kycBankFormData.bankName,
            institutionEmail: this.kycBankFormData.institutionEmail,
            institutionAddress: this.kycBankFormData.institutionAddress,

            // Personal information
            bvn: this.localFormData.bvn,
            pep: this.localFormData.pep,
            id: this.localFormData.id,
            emailAddress: this.localFormData.emailAddress,
            firstName: this.localFormData.firstName,
            lastName: this.localFormData.lastName,
            middleName: this.localFormData.middleName,
            phoneNumber: this.localFormData.phoneNumber,
            title: this.localFormData.title,

            // Identification information
            meansOfIdentification: this.localFormData.meansOfIdentification,
            idNumber: this.localFormData.idNumber,
            meansOfIdentificationIssueDate: this.localFormData.meansOfIdentificationIssueDate,
            meansOfIdentificationExpiryDate: this.localFormData.meansOfIdentificationExpiryDate,
            meansOfIdentificationPlaceOfIssue: this.localFormData.meansOfIdentificationPlaceOfIssue,

            // Director document information
            directorID: {
              url: this.kycDirectorFile.url,
              documentId: this.kycDirectorFile.documentId,
              type: this.localFormData.meansOfIdentification,
              fileExtension: this.kycDirectorFile.fileExtension,
              expiryDate: this.localFormData.meansOfIdentificationExpiryDate,
              documentName: this.localFormData.meansOfIdentification,
            },
          })

          const directorData = createDirectorData()
          if (this.actionType === 'edit') {
            this.tableItems[this.selectedDirectorIndex] = {
              ...this.tableItems[this.selectedDirectorIndex],
              ...directorData,
            }
            this.alertSuccess({
              text: `Your request to ${this.directorButtonLabel} KYC Information was successful`,
            })
          }

          this.emitFormUpdate()
        } else {
          // Get all kycInformationRules Errors
          const errorMessages = []
          Object.keys(this.$refs.kycInformationRules.errors).forEach(key => {
            const value = this.$refs.kycInformationRules.errors[key]

            if (Array.isArray(value) && value.length > 0) {
              value.forEach(error => {
                errorMessages.push(`${error}`)
              })
            }
          })
          this.allValidationErrors = errorMessages
          this.$root.$emit('bv::show::modal', 'all-validated-modal')
        }
      })
    },
    async deleteKYCDirector() {
      const deleteDirector = async () => {
        this.isKycBusy = true
        this.tableItems = this.tableItems.filter((item, i) => i !== Number(this.selectedDirectorIndex))
        this.alertSuccess({
          text: 'Director Removed',
        })
        this.emitFormUpdate()
        this.isKycBusy = false
      }
      this.confirm(deleteDirector, { title: '', text: 'Are you sure you want to delete this Director?' })
    },
    async handleKYCFileUpload(event, fileObjectPath, imageType) {
      const documentFilePath = this[fileObjectPath]

      const { files } = event.target

      documentFilePath.validationError = ''
      this.kycDocumentIdentifier = uuidv4()

      if (!files || !files[0]) {
        documentFilePath.validationError = 'Please select a file.'
        return
      }

      const file = files[0]
      const maxSizeMB = 5
      if (file.size > maxSizeMB * 1024 * 1024) {
        documentFilePath.validationError = `File size exceeds ${maxSizeMB}MB limit.`
        return
      }

      try {
        documentFilePath.loading = true

        const formData = new FormData()
        formData.append('attachedFile', file)
        formData.append('type', 'Others')
        formData.append('referenceNumber', this.kycDocumentIdentifier)

        const response = await this.uploadDocumentImages({
          formData,
          permission: lmsPermissions.VIEW_PFI_ONBOARDING,
        })

        const { status, data } = response
        if (status === 200 && data) {
          let extensionType
          if (data.fileExtension === 'vnd.openxmlformats-officedocument.wordprocessingml.document') {
            extensionType = 'docx'
          } else if (data.fileExtension === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            extensionType = 'xlsx'
          } else {
            extensionType = null
          }

          documentFilePath.url = data.url
          documentFilePath.documentId = data.id
          documentFilePath.fileExtension = extensionType !== null ? extensionType : data.fileExtension
          documentFilePath.type = imageType

          documentFilePath.loading = false

          this.toastAlert({
            title: this.$t('Document uploaded successfully'),
          })
        }
      } catch (error) {
        error.response.data.errors.forEach(err => {
          this.alertError({
            text: `Upload failed: ${err.errorMessage}`,
          })
        })
      } finally {
        documentFilePath.loading = false
      }
    },
    async bvnValidateAction(item) {
      try {
        this.isKycLoading = true
        this.showSpinner = true
        const formData = {
          bvnNumber: item.bvn,
        }
        const response = await this.validateBVN({ formData, permission: accountPermissions.VALIDATE_BVN })
        const { data, status } = response
        if (status === 200 && data.result) {
          this.alertSuccess({ text: 'Your request to validate BVN was successful?' })
          this.showSpinner = false
          this.isKycLoading = false
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showSpinner = false
        this.isLoading = false
      }
    },
    getFileExtension(url) {
      try {
        const urlObj = new URL(url)
        const params = new URLSearchParams(urlObj.search)

        const documentId = params.get('DocumentId')
        if (!documentId) return null

        const parts = documentId.split('.')
        return parts.length > 1 ? parts.pop() : null
      } catch (err) {
        console.error('Invalid URL:', err)
        return null
      }
    },
    async handleDocumentDownload(url) {
      try {
        this.isBusy = true

        const response = await fetch(url, {
          method: 'GET',
          headers: {
            Accept: '*/*',
          },
        })

        if (response.ok) {
          const blob = await response.blob()
          // Extract filename from URL or use title
          const filename = new URL(url).pathname.split('/').pop()
          const extension = this.getFileExtension(url)
          if (extension === 'document') {
            FileSaver.saveAs(blob, `${filename}.docx`)
          } else if (extension === 'sheet') {
            FileSaver.saveAs(blob, `${filename}.xlsx`)
          } else {
            FileSaver.saveAs(blob, `${filename}.csv`)
          }
          this.alertSuccess({
            text: 'Your request to download file was successful',
          })
        } else {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`)
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isBusy = false
      }
    },

    handleDownload(url) {
      try {
        const extension = this.getFileExtension(url)
        if (extension === 'document' || extension === 'sheet' || extension === 'csv') {
          this.handleDocumentDownload(url)
        } else {
          const link = document.createElement('a')
          link.href = url

          // Extract filename from URL or use title
          const filename = new URL(url).pathname.split('/').pop()
      || this.viewDocumentModalTitle.replace(/\s+/g, '_')

          link.setAttribute('download', filename)
          link.style.display = 'none'
          document.body.appendChild(link)

          // Trigger download
          link.click()
          this.alertSuccess({ text: 'Your request to download file was successful' })

          // Clean up
          document.body.removeChild(link)
        }
      } catch (error) {
        this.alertError({ text: 'Download may have been blocked. Please check your browser.' })
      }
    },

    onViewDocumentFile(url, title) {
      // Reset previous state
      this.showSpinnerDoc = true
      this.fileExtension = null
      this.viewDocumentData = null
      const params = new URL(url).searchParams
      const fileName = params.get('DocumentId') // get full name
      const ext = fileName.split('.').pop() // extract extension

      this.fileExtension = ext
      // this.viewDocumentData = url
      this.viewDocumentModalTitle = title

      this.loadDocument(url)
      // this.$root.$emit('bv::show::modal', 'view-document-modal')
    },

    onDocumentLoaded() {
      this.showSpinnerDoc = false
    },
    onDocumentError() {
      this.showSpinnerDoc = false
      // this.alertError({ text: 'Failed to load document.' })
    },

    loadDocument(url) {
      // For images, preload to handle loading state
      if (['png', 'jpeg', 'jpg', 'bmp'].includes(this.fileExtension)) {
        const img = new Image()
        img.onload = () => {
          this.viewDocumentData = url
          this.showSpinnerDoc = false
          this.$root.$emit('bv::show::modal', 'view-document-modal')
        }
        img.onerror = () => {
          this.showSpinnerDoc = false
          this.alertError({ text: 'Failed to load image' })
        }
        img.src = url
      } else { // For PDFs and other files
        this.viewDocumentData = url
        this.showSpinnerDoc = false
        this.$root.$emit('bv::show::modal', 'view-document-modal')
      }
    },
    resetDocumentModal() {
      this.fileExportFormat = ''
      this.viewDocumentData = ''
      this.viewDocumentModalTitle = ''
    },
    async onKycDocumentFileUpload(event) {
      try {
        if (this.localFormData.meansOfIdentification) {
          this.kycDocumentIdentifier = uuidv4()
          this.kycDirectorFile.loading = true
          const { target } = event
          const formData = new FormData()
          if (typeof target.files[0] !== 'string') {
            formData.append('attachedFile', target.files[0])
            formData.append('type', this.localFormData.meansOfIdentification)
            formData.append('referenceNumber', this.kycDocumentIdentifier)
          }
          const response = await this.uploadDocumentImages({ formData, permission: lmsPermissions.VIEW_PFI_ONBOARDING })

          const { status, data } = await response
          if (status === 200 && data) {
            let extensionType
            if (data.fileExtension === 'vnd.openxmlformats-officedocument.wordprocessingml.document') {
              extensionType = 'docx'
            } else if (data.fileExtension === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
              extensionType = 'xlsx'
            } else {
              extensionType = null
            }
            this.kycDirectorFile.url = data.url
            this.kycDirectorFile.documentId = data.id
            this.kycDirectorFile.fileExtension = extensionType !== null ? extensionType : data.fileExtension
            this.kycDirectorFile.loading = false
          }
        } else {
          this.alertError({ text: 'Please select a Means of Identification first' })
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          this.alertError({ text: `Image upload failed. Reason: ${responseError.errorMessage}` })
        })
      } finally {
        this.kycDirectorFile.loading = false
      }
    },

    clearKycDocumentImage() {
      this.kycDocumentImage = null
      this.kycDocumentImageSrc = null
      this.hasKycDocumentImage = false
      this.$emit('document-cleared', 'kyc-document')
    },

    viewDocumentFile(src, docType) {
      this.$emit('view-document', { src, docType })
    },

    // Location related methods
    getLGAByState(stateCode) {
      this.$emit('get-lga-by-state', stateCode)
    },

    // Table action handlers
    handleBvnValidate(item) {
      this.$emit('validate-bvn', item)
    },

    handleTableRowAction(item, actionType, index) {
      this.$emit('row-action', { item, actionType, index })
    },

    // Utility methods for parent component integration
    // emitFormUpdate() {
    //   this.$emit('update:form-data', this.localFormData)
    //   this.$emit('form-update', this.localFormData)
    // },

    validate() {
      return this.$refs.kycInformationRules.validate()
    },

    reset() {
      this.localFormData = {}
      this.clearKycDocumentImage()
      this.$refs.kycInformationRules.reset()
    },
    updateDocumentUrl(url) {
      this.kycDocumentImageSrc = url
      this.uploadKycLoadSpinner = false
    },
    updateData(newData) {
      if (newData) {
        this.localFormData = { ...newData }
        // Update document image if provided
        if (newData.documentImage) {
          this.kycDocumentImageSrc = newData.documentImage
          this.hasKycDocumentImage = true
        }
      }
    },
  },
}
</script>

  <style scoped>
 .upload-image{
    border: 2px dashed #DCD9D9;
    min-height: 250px;
    position: relative;
    width: 100%;
}
.upload-instruction{
  padding-top: 22%;
  color: #000;
  text-align: center;
}

.trash {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  background: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-right: 10px;
  cursor: pointer;
}
.view-details {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-left: 10px;
  cursor: pointer;
}
  .format {
    font-size: 0.8rem;
    color: #6c757d;
  }
  .upload-label {
  color: #5e5873;
  font-size: 0.857rem;
  margin-bottom: 0.2857rem;
}
.form-section {
  padding-bottom: 15px;
  margin-bottom: 15px;
}

.form-section:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.upload-id-photo {
  max-width: 300px;
  margin: 0 auto;
}
.text-primary {
  color: var(--primary) !important
}
form input[type=file]{
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
}
  </style>
